export default __webpack_public_path__ + "static/media/0xa062fc09ca6bdeb2f6e3b77e1d4e09c42c964742.99ad3ed7.jpeg";